import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://api.ntregenerative.com/api",
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (res) => res,
  (error) => {
    console.log("error:", error);
    // const status = error?.response?.status;
    // if (status === 401) {
      // localStorage.removeItem("token");
      // window.location.href = "/login";
    // }
    return Promise.reject(error);
  }
);


export default axiosInstance;
